import LoadingScreen from './loadingScreen';
export default LoadingScreen;
